import { render, staticRenderFns } from "./DecidedOpportunity.vue?vue&type=template&id=d60a0cb2&"
import script from "./DecidedOpportunity.vue?vue&type=script&lang=js&"
export * from "./DecidedOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./DecidedOpportunity.vue?vue&type=style&index=0&id=d60a0cb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports